import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { TopClickNavComponent } from './top-click-nav/top-click-nav.component';
import { TopSecondaryNavComponent } from './top-secondary-nav/top-secondary-nav.component';
import { SearchNavComponent } from './search-nav/search-nav.component';
import { FormsModule } from '@angular/forms';
import { SideNavComponent } from './side-nav/side-nav.component';

@NgModule({
	declarations: [
		TopClickNavComponent, TopSecondaryNavComponent, SearchNavComponent, SideNavComponent
	],
	imports: [
		RouterModule,
		CommonModule,
		FormsModule
	],
	exports: [ TopClickNavComponent, TopSecondaryNavComponent, SearchNavComponent, SideNavComponent ]
})
export class NavigationModule { }
